<template>
  <div class="schoolprofile">
    <div class="content">
      <h1>
        <div class="row">
          <div class="col-md-1">
            <div class="titles">实践课</div>
          </div>
          <div class="col-md-11">
            <ul class="coursetab">
              <li v-for="(tab,index) in tabs" :class="{active:num==index}" @click="table(index)" class="btn">{{tab}}
              </li>
            </ul>
          </div>
        </div>
      </h1>
      <div class="clearfix margin-bottom-20"></div>
      <div class="tabContent">
        <div class="divTab">
          <div class="row ">
            <div class="col-md-4" v-for="item in arrs" :key="item.id">
              <router-link to="/">
                <div class="course">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="course-img">
                        <img :src="item.imgUrl" width="176" height="100">
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="course-detail course-title">
                        计算机科学与技术
                      </div>
                      <div class="course-detail course-num">
                        代码：03683
                      </div>
                      <div class="course-detail course-style">
                        课程类型：基础课
                      </div>
                      <div class="course-detail ">
                        成绩：<span class="course-score">99</span>
                      </div>
                    </div>
                  </div>
                  <div class="buttons">
                    <div class="row">
                      <div class="col-md-4 text-center">
                        <button class="course-btn active">下载要求</button>
                      </div>
                      <div class="col-md-4 text-center">
                        <button class="course-btn">提交设计</button>
                      </div>
                      <div class="col-md-4 text-center">
                        <router-link to="/submissionrecords"><button class="course-btn">提交记录</button></router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <div class="text-center margin-bottom-20">
            <div class="page">
              <button class="btn btn-default margin-right-10" :class="{'active':activenum === 0}" type="submit"
                      @click="primaryPage">首页
              </button>
              <button class="btn btn-default margin-right-10" type="submit" @click="prePage"
                      :class="{'active':activenum === 1}">上页
              </button>
              <button class="btn btn-default margin-right-10" type="submit" @click="nextPage"
                      :class="{'active':activenum === 2}">下页
              </button>
              <button class="btn btn-default margin-right-10" type="submit" @click="lastPage"
                      :class="{'active':activenum === 3}">尾页
              </button>
              <button class="btn btn-default" type="submit" style="background: none">
                {{current_page}}/{{Math.ceil(arrs.length/pagesize)}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PlanList',
  props: {
    arrs: Array
  },
  data: function () {
    return {
      currentPage: 1, // 当前页号
      activenum: 0, // 每页大小
      pagesize: 5,
      tabs: ['第一学期', '第二学期', '第三学期'],
      tabsCon: ['内容1', '内容2', '内容3'],
      num: 0
    }
  },
  methods: {
    primaryPage () {
      this.currentPage = 1
      this.activenum = 0
    },
    prePage () {
      if (this.currentPage === 1) {
        this.activenum = 1
        return
      }
      this.currentPage = this.currentPage - 1
      this.activenum = 1
    },
    nextPage () {
      if (this.currentPage === Math.ceil(this.arrs.length / this.pagesize)) {
        return
      }
      this.currentPage = this.currentPage + 1
      this.activenum = 2
    },
    lastPage () {
      this.currentPage = Math.ceil(this.arrs.length / this.pagesize)
      this.activenum = 3
    },
    table (index) {
      this.num = index
    }
  }
}
</script>
<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  .schoolprofile
    .content
      width: $pageWidth
      margin: 0 auto
      .choose {
        text-align center
      }
      h1 {
        font-size: 18px;
        font-weight bold;
        margin-bottom: 20px;
        .english {
          color: #999;
          font-size: 14px;
          font-weight: normal;
          text-transform: Uppercase;
        }
      }
    .course {
      margin-bottom: 30px;
      padding: 28px;
      background: #f8fefc;
      width: 100%;
      &:hover {
        box-shadow: 0px 0px 10px #999;
      }
      a {
        color: #333;
        & .course-des {
          color: $fontGray;
        }
      }
      .course-img {
        img {
          width: 176px;
          height: 100px;
        }
      }
      .course-title {
        font-size: 18px;
        line-height: 20px;
        font-weight: bold;
        color: #333;
        margin-bottom: 10px;
      }
      .course-des {
        margin-top: 10px;
        line-height: 20px;
        color: #999;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    .choose {
      width: 300px;
      margin: 0 auto;
      .btn {
        width: 90px;
        border: 1px solid $borderColor;
        margin-bottom: 20px;

      }
    }

  .choose li {
    float: left;
  }

  .active {
    background: $bgColor;
    color: #fff;
    border: 1px solid $bgColor;
  }

  .btn:focus, .btn.focus {
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .more {
    font-size: 14px;
    font-weight: normal;
    &:hover {
      text-decoration none;
    }
  }

  a.more {
    color: #999;
  }

  .divTab {
    background: #fff;
    padding: 28px;
  }

  .course {
    margin-bottom: 20px;
  }

  .course-detail {
    color: #999;
    margin-bottom: 6px;
    .course-score {
      font-size: 18px;
      font-weight: bold;
      color: $bgColor;
    }
  }

  .buttons {
    margin-top: 20px;
  }

  .examinationtime {
    color: #999;
  }

  .course-btn {
    display: inline-block;
    height: 30px;
    line-height: 30px;
    width: 92px;
    height: 30px;
    background: #ccd1cf;
    line-height: 30px;
    border-radius: 15px;
    color: #fff;
    border: none;
    margin-top: 20px;
    margin-bottom: 20px;
    margin-right:15px;
    &.active {
      background: $bgColor;
    }
  }

  .examinationtime p {
    margin-bottom: 10px;
  }

  .coursetab {

  }
  .order{
    float:right;
    font-size:14px !important;
    font-weight:normal !important;
    color:#999;
    position:relative;
    top:8px;
  }
  .titles{
    position:relative;
    top:8px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/myclass/components/PlanList.vue